import { DrawingManager, DrawingManagerProps } from "@react-google-maps/api"
import React from "react"
import { LatLng } from "utils/custom.types"
import { generateId } from "utils/custom.utils"
interface PolyDetails {
  id: string
  coordinates: LatLng[]
  area: number
  center: LatLng
}
interface CustomDrawingManagerProps extends DrawingManagerProps {
  onPolyComplete?: (polyDetails: PolyDetails) => void
}
const CustomDrawingManager = ({
  onPolyComplete,
  onCircleComplete,
  onRectangleComplete,
  drawingMode,
}: CustomDrawingManagerProps) => {
  function handlePolylineComplete(e: any) {
    // Hide the default polygon, since we are going to map our own state based polygons
    e.setVisible(false)

    const bounds = new window.google.maps.LatLngBounds()
    const path = e.getPath()
    const area = window.google.maps.geometry.spherical.computeArea(path)
    const polyArray: LatLng[] = []
    for (let i = 0; i < path.getLength(); i++) {
      const latlng = path.getAt(i)?.toJSON()
      bounds.extend(latlng)
      polyArray.push(latlng)
    }
    const center = bounds?.getCenter()?.toJSON()

    onPolyComplete &&
      onPolyComplete({
        // Helps us close the polygon
        coordinates: polyArray.concat(polyArray?.[0]),
        area,
        center,
        id: generateId(),
      })
  }

  function handleCircleComplete(e: any) {
    onCircleComplete &&
      onCircleComplete({
        radius: e.radius,
        center: e.getCenter()?.toJSON(),
      } as any)
  }

  function handleRectangleComplete(e: any) {
    var NE = e.bounds.getNorthEast()
    var SW = e.bounds.getSouthWest()
    // North West
    var NW = new window.google.maps.LatLng(NE.lat(), SW.lng())
    // South East
    var SE = new window.google.maps.LatLng(SW.lat(), NE.lng())

    onRectangleComplete &&
      onRectangleComplete({
        NE: NE.toJSON(),
        SW: SW.toJSON(),
        NW: NW.toJSON(),
        SE: SE.toJSON(),
      } as any)
  }

  return (
    <DrawingManager
      options={{
        drawingControlOptions: {
          drawingModes: drawingMode as any,
          position: window.google.maps.ControlPosition.BOTTOM_LEFT,
        },
      }}
      onRectangleComplete={handleRectangleComplete}
      onPolygonComplete={handlePolylineComplete}
      onPolylineComplete={handlePolylineComplete}
      onCircleComplete={handleCircleComplete}
    />
  )
}

export default CustomDrawingManager
/* TODO - Make a modular component */
